module.exports = __webpack_public_path__ + "static/images/zeitgeist-minds.3b8023d53ef0b779f16ba3875f52ce96.jpg";